"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/styles");
var useSelectStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    select: {
      '&:focus': {
        borderRadius: 4,
        backgroundColor: 'transparent'
      },
      '.Mui-focused:hover &': {
        border: "2px solid ".concat(theme.palette.BLUE500)
      },
      lineHeight: theme.typography.pxToRem(18) // required so letter g is not cut off on smaller screens
    },

    required: {
      color: theme.palette.RED400
    },
    emptyValue: {
      fontWeight: 400,
      color: theme.palette.NEUTRAL300
    },
    icon: {
      right: 12,
      color: theme.palette.NEUTRAL700,
      '&.Mui-disabled': {
        color: theme.palette.NEUTRAL300
      }
    },
    containerInput: {
      position: 'relative',
      '&:hover $clearAll': {
        opacity: 1
      }
    },
    clearAll: {
      color: theme.palette.NEUTRAL700,
      fontSize: theme.typography.pxToRem(16),
      display: 'flex',
      alignItems: 'center',
      position: 'absolute',
      right: 40,
      top: 'calc(50% - 8px)',
      backgroundColor: 'transparent',
      border: 'none',
      padding: 0,
      opacity: 0,
      cursor: 'pointer'
    },
    clearAllFocused: {
      opacity: 1
    }
  };
});
var _default = useSelectStyles;
exports.default = _default;